import { FormBase } from 'core/components';

export default class BulkPrintForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			fields: [
				'fulfillmentOrders',
				'fulfillmentOrders[].id',
				'fulfillmentOrders[].boxId',
				'fulfillmentOrders[].isBoxRequired',
			],
			labels: {
				'fulfillmentOrders[].box': 'FULFILLMENTORDER.BULKPRINT.BOXDIMENSIONS',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/BulkPrintForm.js